module.exports = __webpack_public_path__ + "img/toggle-off.cea28d16.svg";